import React from 'react';
import { Link } from 'react-router-dom';
import { ApplicationRoutes } from 'containers/System/routes';
import logo from 'assets/images/logo.png';
const Logo = () => (React.createElement("div", { className: "logo" },
    React.createElement(Link, { to: ApplicationRoutes.root },
        React.createElement("img", { src: logo, alt: "Special Appearance Attorneys - Attorneys in Motion", title: "Special Appearance Attorneys - Attorneys in Motion" }))));
export default Logo;
